// extracted by mini-css-extract-plugin
module.exports = {"secondary":"Text_secondary__2My5S","danger":"Text_danger__1MxfX"};